import { render } from "./gestioneLead.vue?vue&type=template&id=1452eacd&ts=true"
import script from "./gestioneLead.vue?vue&type=script&lang=ts"
export * from "./gestioneLead.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\CarpeDiem\\AntiSmoking\\Backend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__